<template>
<transition
  name="nav-transition"
  mode="out-in"
>
  <div
    v-show="isOpened"
    class="rr-mobile-nav"
  >
    <div
      class="rr-mobile-nav__overlay"
      @click="close"
    />
    <div class="rr-mobile-nav__container">
      <div class="rr-mobile-nav__header">
        <slot name="logo" />
        <RrButton
          class="rr-mobile-nav__close"
          variant="clear"
          shape="square"
          icon-left="close"
          @click="close"
        />
      </div>
      <div class="rr-mobile-nav__body">
        <template
          v-for="(link, i) in nav"
        >
          <div
            v-if="link.divider"
            class="rr-mobile-nav__divider"
            :key="`divider-${i}`"
          ></div>
          <NavigationItem
            v-else
            :key="link.text"
            v-bind="{
              ...link,
              icon: link.icon || 'caret-right',
            }"
          ></NavigationItem>
        </template>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import NavigationItem from './NavigationItem.vue'
import RrButton from '@rr-component-library/button/src/main'

export default {
  name: 'HeaderMobileNav',
  designVersion: '2.0.0',
  designLink: 'https://www.figma.com/file/MAH9taJUL2HzqvGofNpg5Z/Components?node-id=1256%3A67',
  components: {
    NavigationItem,
    RrButton
  },
  model: {
    prop: 'isOpened',
    event: 'change'
  },
  props: {
    nav: {
      type: Array,
      default: () => []
    },
    isOpened: Boolean
  },
  methods: {
    open () {
      this.$emit('change', true)
    },
    close () {
      this.$emit('change', false)
    }
  },
  watch: {
    isOpened: {
      handler (val) {
        document.body.style.overflow = val ? 'hidden' : ''
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.rr-mobile-nav {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s;

  &__container {
    position: relative;
    z-index: 1;
    width: 296px;
    max-width: 100%;
    height: 100%;
    background-color: $color-white;
    overflow-x: hidden;
    transform: translateX(0%);
    transition: 0.3s ease-in-out transform;

    .nav-transition-enter &,
    .nav-transition-leave-to & {
      transform: translateX(-100%);
    }
  }

  &__overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: map_get($color-neutral-black, 85);
    transition: 0.3s ease-in-out opacity;

    .nav-transition-enter &,
    .nav-transition-leave-to & {
      opacity: 0;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 56px;
    padding: 0 12px;
    justify-content: space-between;
  }

  &__body {
    padding: 8px 8px 40px;
    margin-top: 16px;
  }

  &__close {
    flex: 0 0 auto;
    margin-right: -8px;
  }

  &__divider {
    flex: 0 0 auto;
    height: 1px;
    background-color: map_get($color-neutral-black, 15);
    margin: 8px 16px;
  }
}
</style>
